module.exports = __webpack_public_path__ + "img/inactive-17.1d45d17f.svg";